module.exports = __webpack_public_path__ + "fonts/3MCircularTT-Bold.f09a94e8.eot";